import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserRoleService {

  constructor() { }

  /**
   * Get current user role from localStorage
   */
  private getCurrentUserRole(): string | null {
    const loginData = localStorage.getItem('login');
    if (loginData) {
      try {
        const user = JSON.parse(loginData);
        return user?.role || null;
      } catch (error) {
        console.error('Error parsing user data from localStorage:', error);
        return null;
      }
    }
    return null;
  }

  /**
   * Check if current user is Super User
   */
  isSuperUser(): boolean {
    return this.getCurrentUserRole() === 'SUPER';
  }

  /**
   * Check if current user is Admin
   */
  isAdmin(): boolean {
    return this.getCurrentUserRole() === 'ADMIN';
  }

  /**
   * Check if current user is Franchise Owner
   */
  isFranchiseOwner(): boolean {
    return this.getCurrentUserRole() === 'FRANCHISE_OWNER';
  }

  /**
   * Check if current user is Franchisee
   */
  isFranchisee(): boolean {
    return this.getCurrentUserRole() === 'FRANCHISEE';
  }
}
